import { render, staticRenderFns } from "./caseprocess1.vue?vue&type=template&id=28f10dce&"
import script from "./caseprocess1.vue?vue&type=script&lang=js&"
export * from "./caseprocess1.vue?vue&type=script&lang=js&"
import style0 from "./caseprocess1.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports